import { useFormikContext } from 'formik';
import type { ComponentProps } from 'react';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { selectableWorkflowsOf } from '../../../utils/selectable-workflows.util';

import { FolderBusinessEntityGeneralInfoFormStep } from '../../FolderBusinessEntity/steps/GeneralInfo';
import { FormVariant } from '../../enums/variant.enum';

import { useMissionWorkflowFamily } from '../hooks/useMissionWorkflowFamily.hook';
import { filterMissionWorkflowsOfKind } from '../utils/mission-workflows-of-kind.util';
import type { MissionForm_Mission } from '../fragments/mission.fragment';

type Props = Omit<
  ComponentProps<typeof FolderBusinessEntityGeneralInfoFormStep>,
  'workflows'
> &
  Readonly<{ formVariant: FormVariant }>;

// The workflows follow the current kind of the mission, which the
// collaboration step changes when the mission is attached or detached; an
// existing mission keeps the workflows of its family.
export const MissionGeneralInfoFormStep = ({
  fallbackDescribable,
  formVariant,
  id,
  type,
}: Readonly<Props>) => {
  const { initialValues, values } = useFormikContext<MissionForm_Mission>();
  const { missionWorkflows } = useReferencesContext();
  const { familyMissionWorkflows } = useMissionWorkflowFamily(
    initialValues.workflowId,
  );
  const workflows =
    formVariant === FormVariant.Modification
      ? familyMissionWorkflows
      : missionWorkflows;

  return (
    <FolderBusinessEntityGeneralInfoFormStep
      fallbackDescribable={fallbackDescribable}
      id={id}
      type={type}
      workflows={filterMissionWorkflowsOfKind(
        selectableWorkflowsOf(workflows),
        values.kind,
      )}
    />
  );
};
